import api from '../api';

const DIRECT_FILE_REFERENCE_PATTERN = /^(?:data|blob):/i;

export const resolveDirectFileReference = (file) => {
  const candidates = [file?.dataUrl, file?.url];

  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const normalized = candidate.trim();
    if (DIRECT_FILE_REFERENCE_PATTERN.test(normalized)) {
      return normalized;
    }
  }

  return '';
};

const normalizeLegacyFileQuery = (urlValue) => {
  if (typeof urlValue !== 'string' || !urlValue.includes('?')) {
    return urlValue;
  }

  const [withoutHash, hash = ''] = urlValue.split('#');
  const [pathname, query = ''] = withoutHash.split('?');
  if (!query || /(?:^|&)name=/i.test(query)) {
    return urlValue;
  }

  const legacyMatch = query.match(/(?:^|&)path=([^&]*?)(?:_?name=)([^&]*)/i);
  if (!legacyMatch) {
    return urlValue;
  }

  const [, legacyPath = '', legacyName = ''] = legacyMatch;
  const sanitizedPath = legacyPath.replace(/[?_]+$/, '');
  const normalizedParams = new URLSearchParams(query.replace(legacyMatch[0], '').replace(/^&+|&+$/g, ''));
  if (sanitizedPath) {
    normalizedParams.set('path', sanitizedPath);
  }
  if (legacyName) {
    normalizedParams.set('name', legacyName);
  }

  const normalizedQuery = normalizedParams.toString();
  const normalizedUrl = normalizedQuery ? `${pathname}?${normalizedQuery}` : pathname;

  return hash ? `${normalizedUrl}#${hash}` : normalizedUrl;
};

export const resolveDownloadPath = (downloadUrl) => {
  if (!downloadUrl) return '';

  const normalizedInput = normalizeLegacyFileQuery(downloadUrl);

  try {
    const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const fallbackOrigin = runtimeOrigin || 'https://localhost';
    const baseOrigin = api?.defaults?.baseURL || fallbackOrigin;
    const base = new URL(baseOrigin, fallbackOrigin);
    const target = new URL(normalizedInput, base);

    if (target.host === base.host) {
      return `${target.pathname}${target.search}`;
    }

    return target.toString();
  } catch (error) {
    return normalizedInput;
  }
};

export default resolveDownloadPath;
